import { ButtonLink, EmptyState, EmptyStateIcons, Icon, IconButton, Icons, Search } from '@silverfort/sf-components';
import { useEffect, useState } from 'react';
import IpSelector from './components/IpSelector';
import ImportFromFileButton from './components/ImportFromFileButton';
import useGetIpListFromFile from './hooks/useGetIpListFromFile';

const AddIpResourceContainer = ({ onClear, onDeleteResource, onAddResource, resourceState }) => {
    const [displayedIps, setDisplayedIps] = useState(resourceState.selectedIps);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const { getIpListFromFile, isLoading, error } = useGetIpListFromFile();
    const handleSearch = (text) => {
        if (text) {
            setDisplayedIps(resourceState.selectedIps.filter((ip) => ip.includes(text)));
        } else {
            setDisplayedIps(resourceState.selectedIps);
        }
    };

    const handleUploadFile = async (file) => {
        const ips = await getIpListFromFile(file);
        const newIps = ips.filter((ip) => !resourceState.selectedIps.includes(ip));

        if (ips) {
            onAddResource(newIps);
        }
    };

    const handleAddIp = (ip) => {
        onAddResource(ip);
    };

    useEffect(() => {
        setDisplayedIps(resourceState.selectedIps);
    }, [resourceState.selectedIps]);

    return (
        <div className="flex flex-col border border-sf-gray-100 rounded-lg text-sf-gray-800 flex-1 overflow-auto">
            <div className="px-4 py-3 border-b border-b-sf-gray-100 flex items-center">
                <div className="flex flex-1">
                    <span className="text-[13px] font-medium">{`Selected (${resourceState.selectedIps.length})`}</span>
                </div>
                <div className="flex gap-2">
                    <IpSelector
                        selectedIps={resourceState.selectedIps}
                        onAdd={handleAddIp}
                        isOpen={isMenuOpen}
                        onClose={() => setIsMenuOpen(false)}
                    />
                    <ImportFromFileButton onFileUploaded={handleUploadFile} fileLoading={isLoading} error={!!error} />
                </div>
            </div>
            <div className="pl-2 pr-4 h-12 flex flex-row border-b border-b-sf-gray-100 justify-between items-center">
                <Search placeholder="Search added IPs" className="h-8" onChange={handleSearch} />
                <ButtonLink className="text-[13px] font-normal" onClick={onClear} text="Clear All" underline />
            </div>
            <div className="p-4 flex flex-col gap-2 flex-1 overflow-auto">
                {resourceState.selectedIps.length === 0 ? (
                    <EmptyState
                        title="No resources added"
                        description="Add resources by clicking Add Resource button"
                        actionText="Add Resource"
                        className="w-full h-full"
                        icon={EmptyStateIcons.NoItems}
                        onActionClick={() => setIsMenuOpen(true)}
                    />
                ) : (
                    displayedIps.map((ip, index) => (
                        <div key={index} className="flex flex-row justify-between items-center px-2">
                            <div className="flex flex-row gap-2 items-center">
                                <Icon className="text-sf-gray-400" icon={Icons.Domain} size={16} />
                                <div className="flex flex-col">
                                    <span className="text-13">{ip}</span>
                                    <span className="text-12 text-sf-gray-500">IP</span>
                                </div>
                            </div>
                            <IconButton icon={Icons.Cancel} iconSize={16} onClick={() => onDeleteResource(ip)} />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AddIpResourceContainer;
